import { Routes } from '@angular/router';
import { WelcomeComponent } from './info/welcome.component';
import { activateCtxDependedGuard } from './shared/services/activate-ctxdepended-guard.service';
import { activateGuard } from './shared/services/activate-guard.service';
import { AdminGuardService } from './shared/services/admin-guard.service';
import { deactivateGuard } from './shared/services/deactivate-guard.service';
import { SelectBFComponent } from './businessfuncs/select-bf.component';
import { activateExpertTaskGuard } from './shared/services/activate-expert-task-guard.service';
import { AdminOrModeratorGuardService } from './shared/services/admin-or-moderator-guard.service';

export const routes: Routes = [
  { path: '', redirectTo: 'welcome', pathMatch: 'full' },
  {
    path: '403',
    loadComponent: () =>
      import('./info/page403.component').then((e) => e.Page403Component),
    data: { title: 'Отсутствует доступ' },
  },
  {
    path: 'welcome',
    component: WelcomeComponent,
    data: { title: 'Идеи' },
    canActivate: [activateCtxDependedGuard],
  },
  {
    path: 'thanks',
    loadComponent: () => import('./info/thanks.component').then((e) => e.ThanksComponent),
    data: { title: 'Спасибо за идею' },
  },
  {
    path: 'thanks-expert-task-complete',
    loadComponent: () =>
      import('./info/thanks-expert-task-complete.component').then(
        (e) => e.ThanksExpertTaskCompleteComponent
      ),
    data: { title: 'Спасибо за оценку' },
  },
  {
    path: 'businessfuncs',
    loadComponent: () =>
      import('./businessfuncs/businessfuncs.component').then(
        (e) => e.BusinessFuncsComponent
      ),
    data: { title: 'Бизнес-функции' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'bf-quiz',
    loadComponent: () =>
      import('./bfquiz/bf-quiz-editor.component').then((e) => e.BfQuizEditorComponent),
    data: { title: 'Сценарий выбора БФ' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'start',
    loadComponent: () =>
      import('./bf-selection/bf-start.component').then((e) => e.BfStartComponent),
    data: { title: 'Выбор бизнес-функции' },
  },
  {
    path: 'sbf',
    component: SelectBFComponent,
    data: { title: 'Выбор бизнес-функции' },
  },
  {
    path: 'sbf/:link',
    component: SelectBFComponent,
    data: { title: 'Выбор бизнес-функции' },
  },
  {
    path: 'businessfunc/:id',
    loadComponent: () =>
      import('./businessfuncs/businessfunc.component').then(
        (e) => e.BusinessFuncComponent
      ),
    data: { title: 'Бизнес-функция' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'users',
    loadComponent: () => import('./users/users.component').then((e) => e.UsersComponent),
    data: { title: 'Пользователи' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'user/:id',
    loadComponent: () => import('./users/user.component').then((e) => e.UserComponent),
    data: { title: 'Пользователь' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'groups',
    loadComponent: () =>
      import('./groups/groups.component').then((e) => e.GroupsComponent),
    data: { title: 'Группы - список' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'group/:id',
    loadComponent: () => import('./groups/group.component').then((e) => e.GroupComponent),
    data: { title: 'Группа' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'ideas-v2',
    loadComponent: () =>
      import('./ideas/V2/ideas.component').then((e) => e.IdeasComponent),
    data: { title: 'Идеи - список' },
    canActivate: [activateCtxDependedGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'ideas',
    redirectTo: 'ideas-v2',
  },
  {
    path: 'idea-v2/:id',
    loadComponent: () => import('./ideas/V2/idea.component').then((e) => e.IdeaComponent),
    data: { title: 'Идея' },
    canActivate: [activateExpertTaskGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'idea/:id',
    redirectTo: 'idea-v2/:id',
  },
  {
    path: 'idea/edit-v2/:id',
    loadComponent: () =>
      import('./ideas/V2/ideaedit.component').then((e) => e.IdeaEditComponent),
    data: { title: 'Редактирование идеи' },
    canActivate: [activateCtxDependedGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'idea/edit/:id',
    redirectTo: 'idea/edit-v2/:id',
  },
  {
    path: 'tgideas',
    loadComponent: () =>
      import('./tgideas/tg-ideas.component').then((e) => e.TGIdeasComponent),
    data: { title: 'Идеи TG - список' },
    canActivate: [activateCtxDependedGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'idea-workflow/:id',
    loadComponent: () =>
      import('./ideaworkflows/idea-workflow.component').then(
        (e) => e.IdeaWorkflowComponent
      ),
    data: { title: 'Рабочий процесс идеи' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'questions',
    loadComponent: () =>
      import('./questions/questions.component').then((e) => e.QuestionsComponent),
    data: { title: 'Вопросы - список' },
    canActivate: [activateCtxDependedGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'question/:id',
    loadComponent: () =>
      import('./questions/question.component').then((e) => e.QuestionComponent),
    data: { title: 'Вопрос' },
    canActivate: [activateCtxDependedGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'idea-expert-tasks',
    loadComponent: () =>
      import('./ideaexperttasks/V2/idea-expert-tasks.component').then(
        (e) => e.IdeaExpertTasksComponent
      ),
    data: { title: 'Задачи оценки валидатора - список' },
    canActivate: [activateCtxDependedGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'idea-expert-task/:id',
    loadComponent: () =>
      import('./ideaexperttasks/V2/idea-expert-task.component').then(
        (e) => e.IdeaExpertTaskComponent
      ),
    data: { title: 'Задача оценки валидатора' },
    canActivate: [activateExpertTaskGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'orgunits',
    loadComponent: () =>
      import('./orgunits/orgunits.component').then((e) => e.OrgUnitsComponent),
    data: { title: 'Оргединицы - список' },
    canActivate: [activateCtxDependedGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'select-orgunit',
    loadComponent: () =>
      import('./orgunits/select-orgunit.component').then((e) => e.SelectOrgUnitComponent),
    data: { title: 'Выбор оргединицы' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'orgunit/:id',
    loadComponent: () =>
      import('./orgunits/orgunit.component').then((e) => e.OrgUnitComponent),
    data: { title: 'Оргединица' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'rating',
    loadComponent: () =>
      import('./rating/rating.component').then((e) => e.RatingComponent),
    data: { title: 'Рейтинг пользователей' },
    canActivate: [activateCtxDependedGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'bfgroups',
    loadComponent: () =>
      import('./bfgroups/bfgroups.component').then((e) => e.BFManagementGroupsComponent),
    data: { title: 'Управление группами' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'bfgroup/:id',
    loadComponent: () =>
      import('./bfgroups/bfgroup.component').then((e) => e.BFManagementGroupComponent),
    data: { title: 'Группа' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'badges',
    loadComponent: () =>
      import('./badges/badges.component').then((e) => e.BadgesComponent),
    data: { title: 'Управление бейджами' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'badge/:id',
    loadComponent: () => import('./badges/badge.component').then((e) => e.BadgeComponent),
    data: { title: 'Бейдж' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  { path: 'userprofile', redirectTo: 'userprofile/', pathMatch: 'full' },
  {
    path: 'userprofile/:login',
    loadComponent: () =>
      import('./userprofiles/userprofile.component').then((e) => e.UserProfileComponent),
    data: { title: 'Профиль' },
    canActivate: [activateExpertTaskGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'userprofile/id/:id',
    loadComponent: () =>
      import('./userprofiles/userprofile.component').then((e) => e.UserProfileComponent),
    data: { title: 'Профиль' },
    canActivate: [activateExpertTaskGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'reassigmenttasks',
    loadComponent: () =>
      import('./reassigmenttasks/reassigmenttasks.component').then(
        (e) => e.ReAssigmentTasksComponent
      ),
    data: { title: 'Управление задачами' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'workflows',
    loadComponent: () =>
      import('./workflows/workflows.component').then((e) => e.WorkflowsComponent),
    data: { title: 'Управление рабочими процессами' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'workflow/:id',
    redirectTo: 'workflow-v2/:id',
  },
  {
    path: 'workflow-v2/:id',
    loadComponent: () =>
      import('./workflows/V2/workflow.component').then((e) => e.WorkflowComponent),
    data: { title: 'Рабочий процесс' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'workflow-idea-status-assignment-rule/:id',
    loadComponent: () =>
      import('./workflows/workflow-idea-status-assignment-rule.component').then(
        (e) => e.WorkflowIdeaStatusAssignmentRuleComponent
      ),
    data: { title: 'Правило назначения статуса' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'workflow-question-criteria/:id',
    loadComponent: () =>
      import('./workflows/workflow-question-criteria.component').then(
        (e) => e.WorkflowQuestionCriteriaComponent
      ),
    data: { title: 'Критерий вопросов' },
    canActivate: [activateCtxDependedGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'realizationtasktypes',
    loadComponent: () =>
      import('./realizationtasktypes/realizationtasktypes.component').then(
        (e) => e.RealizationTaskTypesComponent
      ),
    data: { title: 'Управление типами задач реализации' },
    canActivate: [activateCtxDependedGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'realizationtasktype/:id',
    loadComponent: () =>
      import('./realizationtasktypes/realizationtasktype.component').then(
        (e) => e.RealizationTaskTypeComponent
      ),
    data: { title: 'Тип задачи реализации' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'ideastatuses',
    loadComponent: () =>
      import('./ideastatuses/ideastatuses.component').then(
        (e) => e.IdeaStatusesComponent
      ),
    data: { title: 'Управление статусами идей' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'ideastatus/:id',
    loadComponent: () =>
      import('./ideastatuses/ideastatus.component').then((e) => e.IdeaStatusComponent),
    data: { title: 'Статус идеи' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'ideastatusgroupingcategories',
    loadComponent: () =>
      import('./ideastatusgroupingcategories/ideastatusgroupingcategories.component').then(
        (e) => e.IdeaStatusGroupingCategoriesComponent
      ),
    data: { title: 'Категории группировки статусов' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'ideastatusgroupingcategory/:id',
    loadComponent: () =>
      import('./ideastatusgroupingcategories/ideastatusgroupingcategory.component').then(
        (e) => e.IdeaStatusGroupingCategoryComponent
      ),
    data: { title: 'Категория группировки статусов' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'workflowtags',
    loadComponent: () =>
      import('./workflowtags/workflowtags.component').then(
        (e) => e.WorkflowTagsComponent
      ),
    data: { title: 'Управление тегами' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'idealknotifications',
    loadComponent: () =>
      import('./idealknotifications/idea-lk-notifications.component').then(
        (e) => e.IdeaLKNotificationsComponent
      ),
    data: { title: 'Рассылка уведомлений в ЛК' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'force-complete-workflow',
    loadComponent: () =>
      import('./force-complete-workflow/force-complete-workflow.component').then(
        (e) => e.ForceCompleteWorkflowComponent
      ),
    data: { title: 'Принудительное завершение РП' },
    canActivate: [activateGuard, AdminOrModeratorGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'workflowtag/:id',
    loadComponent: () =>
      import('./workflowtags/workflowtag.component').then((e) => e.WorkflowTagComponent),
    data: { title: 'Тег' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'activityeventtypes',
    loadComponent: () =>
      import('./activityeventtypes/activityeventtypes.component').then(
        (e) => e.ActivityEventTypesComponent
      ),
    data: { title: 'Управление типами событий' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'activityeventtype/:id',
    loadComponent: () =>
      import('./activityeventtypes/activityeventtype.component').then(
        (e) => e.ActivityEventTypeComponent
      ),
    data: { title: 'Тип события' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'tradingnetworks',
    loadComponent: () =>
      import('./tradingnetworks/tradingnetworks.component').then(
        (e) => e.TradingNetworksComponent
      ),
    data: { title: 'Управление торговыми сетями' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'tradingnetwork/:id',
    loadComponent: () =>
      import('./tradingnetworks/tradingnetwork.component').then(
        (e) => e.TradingNetworkComponent
      ),
    data: { title: 'Торговая сеть' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'customtradingnetworks',
    loadComponent: () =>
      import('./customtradingnetworks/customtradingnetworks.component').then(
        (e) => e.CustomTradingNetworksComponent
      ),
    data: { title: 'Управление общими торговыми сетями' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'customtradingnetwork/:id',
    loadComponent: () =>
      import('./customtradingnetworks/customtradingnetwork.component').then(
        (e) => e.CustomTradingNetworkComponent
      ),
    data: { title: 'Общая торговая сеть' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'appeals',
    loadComponent: () =>
      import('./appeals/appeals.component').then((e) => e.AppealsComponent),
    data: { title: 'Обращения - список' },
    canActivate: [activateCtxDependedGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'appeal/:id',
    loadComponent: () =>
      import('./appeals/appeal.component').then((e) => e.AppealComponent),
    data: { title: 'Обращение' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'appeal/edit/:id',
    loadComponent: () =>
      import('./appeals/appealedit.component').then((e) => e.AppealEditComponent),
    data: { title: 'Редактирование обращения' },
    canActivate: [activateCtxDependedGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'workflow-instance-issues',
    loadComponent: () =>
      import('./workflowInstanceIssues/workflow-instance-issues/workflow-instance-issues.component').then(
        (e) => e.WorkflowInstanceIssuesComponent
      ),
    data: { title: 'Список проблем запуска РП' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'workflow-instance-issue/:id',
    loadComponent: () =>
      import('./workflowInstanceIssues/workflow-instance-issue/workflow-instance-issue.component').then(
        (e) => e.WorkflowInstanceIssueComponent
      ),
    data: { title: 'Проблема запуска РП' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'idea-fields',
    loadComponent: () =>
      import('./ideaFields/idea-fields/idea-fields.component').then(
        (e) => e.IdeaFieldsComponent
      ),
    data: { title: 'Поля идеи' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'idea-field/:id',
    loadComponent: () =>
      import('./ideaFields/idea-field/idea-field.component').then(
        (e) => e.IdeaFieldComponent
      ),
    data: { title: 'Поле идеи' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'decision-types',
    loadComponent: () =>
      import('./decisiontypes/decision-types/decision-types.component').then(
        (e) => e.DecisionTypesComponent
      ),
    data: { title: 'Типы Решения' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'decision-type/:id',
    loadComponent: () =>
      import('./decisiontypes/decision-type/decision-type.component').then(
        (e) => e.DecisionTypeComponent
      ),
    data: { title: 'Тип Решения' },
    canActivate: [activateGuard, AdminGuardService],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'decisions',
    loadComponent: () =>
      import('./decisions/decisions/decisions.component').then(
        (e) => e.DecisionsComponent
      ),
    data: { title: 'Решения' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'decision/:id',
    loadComponent: () =>
      import('./decisions/decision/decision.component').then((e) => e.DecisionComponent),
    data: { title: 'Решение' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'ideas-report',
    loadComponent: () =>
      import('./reports/ideas-report/ideas-report.component').then(
        (e) => e.IdeasReportComponent
      ),
    data: { title: 'Отчёт по идеям' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'validators-report',
    loadComponent: () =>
      import('./reports/validator-reports/validator-reports.component').then(
        (e) => e.ValidatorReportsComponent
      ),
    data: { title: 'Отчёт по валидаторам' },
    canActivate: [activateGuard],
    canDeactivate: [deactivateGuard],
  },
  {
    path: 'wftasks-not-completed',
    loadComponent: () =>
      import('./reports/wftasks-not-completed-reports/wftasks-not-completed-reports.component').then(
        (e) => e.WFtasksNotCompletedComponent
      ),
    data: { title: 'Отчет о невыполненных задачах РП' },
    canActivate: [activateGuard],
  },
  {
    path: 'task-report',
    loadComponent: () =>
      import('./reports/task-report/task-report.component').then(
        (e) => e.TaskReportComponent
      ),
    data: { title: 'Отчёт по задачам' },
    canActivate: [activateGuard],
  },
  {
    path: 'idea-implementation',
    loadComponent: () =>
      import('./reports/idea-implementations/idea-implementations.component').then(
        (e) => e.IdeaImplementationComponent
      ),
    data: { title: 'Отчет по средней продолжительности реализации идей' },
    canActivate: [activateGuard],
  },
  {
    path: 'expanded-ideas-with-grouping',
    loadComponent: () =>
      import('./reports/expanded-ideas-with-grouping/expanded-ideas-with-grouping.component').then(
        (e) => e.ExpandedIdeasWithGroupingComponent
      ),
    data: { title: 'Отчет по идеям расширенный (группировка)' },
    canActivate: [activateGuard],
  },
  {
    path: 'step-directory',
    loadComponent: () =>
      import('./stepdirectory/step-directory-list/step-directory-list.component').then(
        (e) => e.StepDirectoryListComponent
      ),
    data: { title: 'Справочник шагов' },
    canActivate: [activateGuard, AdminGuardService],
  },
  {
    path: 'step/:id',
    loadComponent: () =>
      import('./stepdirectory/step/step.component').then((e) => e.StepComponent),
    data: { title: 'Шаг' },
    canActivate: [activateGuard, AdminGuardService],
  },
  {
    path: 'logs',
    loadComponent: () => import('./logs/logs.component').then((e) => e.LogsComponent),
    data: { title: 'Логи' },
    canActivate: [activateGuard, AdminGuardService],
  },
  {
    path: 'expanded-ideas-with-statistics',
    loadComponent: () =>
      import('./reports/expanded-ideas-with-statistics/expanded-ideas-with-statistics.component').then(
        (e) => e.ExpandedIdeasWithStatisticsComponent
      ),
    data: { title: 'Отчет по идеям расширенный (статистика)' },
    canActivate: [activateGuard],
  },
  {
    path: 'deduplication-settings',
    loadComponent: () =>
      import('./deduplication-settings/deduplication-settings.component').then(
        (e) => e.DeduplicationSettingsComponent
      ),
    data: { title: 'Настройки дедупликации' },
    canActivate: [activateGuard, AdminGuardService],
  },
  {
    path: 'deduplication-history',
    loadComponent: () =>
      import('./deduplication-history/deduplication-history.component').then(
        (e) => e.DeduplicationHistoryComponent
      ),
    data: { title: 'История дедупликации' },
    canActivate: [activateGuard],
  },
  {
    path: 'similar-ideas/:id',
    loadComponent: () =>
      import('./similar-ideas/similar-ideas.component').then(
        (e) => e.SimilarIdeasComponent
      ),
    data: { title: 'Похожие идеи' },
    canActivate: [activateGuard],
  },
  { path: ':link', redirectTo: 'sbf/:link', pathMatch: 'full' },
];
